"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBox = void 0;
const react_1 = __importStar(require("react"));
const Dialog_1 = require("../Dialog");
const helpers_1 = require("../helpers");
const Icon_1 = require("../Icon");
const constants_1 = require("./helpers/constants");
const MessageBox_styles_1 = require("./MessageBox.styles");
const MessageBoxIconView_1 = require("./types/MessageBoxIconView");
const StackView_1 = require("../StackView");
const View_1 = require("../View");
exports.MessageBox = (0, helpers_1.createUIElement)('MessageBox', (_a, ref) => {
    var { className, header, onRequestClose, children, iconView = MessageBoxIconView_1.MESSAGE_BOX_ICON_VIEW.info, iconSrc, actions, detailContent, isDetailContentShown, detailButtonText = { show: 'Show detail', hide: 'Hide detail' }, hideDetailButton = false, pending, loading, canClose, size = {
        width: Dialog_1.DIALOG_SIZE.s,
        height: Dialog_1.DIALOG_SIZE.auto
    }, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "header", "onRequestClose", "children", "iconView", "iconSrc", "actions", "detailContent", "isDetailContentShown", "detailButtonText", "hideDetailButton", "pending", "loading", "canClose", "size", "onKeyPress", "style", 'data-selector-id']);
    const [isDetailContentShownState, setDetailContentShownState] = (0, react_1.useState)(!!isDetailContentShown);
    (0, react_1.useEffect)(() => {
        setDetailContentShownState(!!isDetailContentShown);
    }, [isDetailContentShown]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'dialog-wrapper', [initialDataSelectorId]);
    const dialogActions = (0, react_1.useMemo)(() => actions || [{ text: 'Ok', onClick: onRequestClose }], [actions, onRequestClose]);
    const dialogSecondaryActions = (0, react_1.useMemo)(() => detailContent && !hideDetailButton
        ? [
            {
                text: isDetailContentShownState
                    ? detailButtonText.hide
                    : detailButtonText.show,
                view: Dialog_1.ACTION_VIEW.text,
                onClick: () => {
                    setDetailContentShownState((state) => !state);
                }
            }
        ]
        : [], [
        detailButtonText.hide,
        detailButtonText.show,
        detailContent,
        hideDetailButton,
        isDetailContentShownState
    ]);
    const icon = (0, react_1.useMemo)(() => iconSrc || constants_1.MESSAGE_BOX_ICONS[iconView], [iconSrc, iconView]);
    return (react_1.default.createElement(Dialog_1.Dialog, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, size: size, canClose: canClose, pending: !!pending, loading: !!loading, onRequestClose: onRequestClose, header: header, actions: dialogActions, secondaryActions: dialogSecondaryActions, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-MessageBox', className) }),
        react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column, indentBottom: View_1.INDENT.s, gap: StackView_1.STACK_GAP.l },
            react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.start, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
                react_1.default.createElement(Icon_1.Icon, { size: Icon_1.ICON_SIZES.xl, src: icon }),
                react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center, spaceFill: View_1.SPACE_FILL.all },
                    react_1.default.createElement(MessageBox_styles_1.StyledMessageBoxText, null, children))),
            isDetailContentShownState ? detailContent : null)));
});
//# sourceMappingURL=MessageBox.js.map